import { MenuItem } from 'primeng/api';

export interface MenuItemModel extends MenuItem {
  header?: boolean;
  permissions?: string;
  items?: MenuItemModel[];
  role?: string;
  active?: boolean;
}
